<script setup lang="ts">
import Navigation from '@/components/custom/Navigation.vue';
import Footer from '@/components/custom/Footer.vue';

const title = 'Spotsurfer | Reserve Parking Before You Arrive';
const description = 'Reserve daily, overnight and season-pass parking at lots near where you’re headed. See the total price up front.';
const image = 'https://spotsurfer.com/images/home/og-home.jpg';

useHead({
  link: [{ rel: 'canonical', href: 'https://spotsurfer.com' }],
  script: [
    {
      type: 'application/ld+json',
      innerHTML: JSON.stringify({
        '@context': 'https://schema.org',
        '@graph': [
          { '@type': 'Organization', name: 'Spotsurfer', url: 'https://spotsurfer.com', logo: 'https://spotsurfer.com/images/spotsurferLogo.png' },
          { '@type': 'WebSite', name: 'Spotsurfer', url: 'https://spotsurfer.com' },
        ],
      }),
    },
  ],
});

useSeoMeta({
  title,
  description,
  ogTitle: title,
  ogDescription: description,
  ogImage: image,
  ogImageWidth: 1200,
  ogImageHeight: 630,
  ogUrl: 'https://spotsurfer.com',
  ogType: 'website',
  ogSiteName: 'Spotsurfer',
  twitterCard: 'summary_large_image',
  twitterTitle: title,
  twitterDescription: description,
  twitterImage: image,
});
</script>

<template>
  <Navigation />
  <main>
    <slot />
  </main>
  <Footer />
</template>
